import React, { useState } from 'react';
import { Check, ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'basico'>('completo');
  const [paymentMethod, setPaymentMethod] = useState<'tarjeta' | 'yape'>('tarjeta');
  const checkoutLinks = {
    basico: {
      tarjeta: 'https://peru.recursodigital.shop/cart/52215675453733:1',
      yape: 'https://pay.hotmart.com/P105301596E'
    },
    completo: {
      tarjeta: 'https://peru.recursodigital.shop/cart/52215677780261:1',
      yape: 'https://pay.hotmart.com/D105301894V'
    }
  };
  return <section id="oferta" className="bg-brand-dark py-5 px-5 scroll-mt-10" data-id="element-202">
      <div className="max-w-xl mx-auto" data-id="element-203">
        {/* Headline */}
        <div className="text-center mb-4" data-id="element-204">
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-2" data-id="element-205">
            Elegí tu{' '}
            <span className="text-brand-yellow" data-id="element-206">
              Mega Pack Afrontar la Vejez de Tus Padres™:
            </span>
          </h2>
          <p className="text-sm text-gray-400" data-id="element-207">
            Las dos opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        {/* Option 1 - Basic */}
        <button onClick={() => setSelected('basico')} className={`w-full text-left bg-gray-900 rounded-xl p-5 mb-4 border-2 transition-all ${selected === 'basico' ? 'border-gray-500' : 'border-gray-800'}`} data-id="element-208">
          <div className="flex items-start justify-between gap-4" data-id="element-209">
            <div className="flex items-start gap-3" data-id="element-210">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'basico' ? 'border-white' : 'border-gray-600'}`} data-id="element-211">
                {selected === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-212" />}
              </div>
              <div data-id="element-213">
                <div className="flex items-center gap-2 mb-1" data-id="element-214">
                  <span className="text-base" data-id="element-215">📘</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-216">
                    MEGA PACK AFRONTAR LA VEJEZ DE TUS PADRES™
                  </h4>
                </div>
                <p className="text-xs text-gray-500" data-id="element-217">6 tomos + 6 bonos</p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-218">
              <div className="text-xs text-gray-600 line-through" data-id="element-219">S/.49.90</div>
              <div className="text-2xl font-black text-white" data-id="element-220">S/.29.90</div>
            </div>
          </div>
        </button>

        {/* Option 2 - Highlighted */}
        <button onClick={() => setSelected('completo')} className={`w-full text-left bg-gray-900 rounded-xl p-5 relative border-2 transition-all ${selected === 'completo' ? 'border-brand-yellow' : 'border-gray-800'}`} data-id="element-221">
          <div className="flex items-start justify-between gap-4" data-id="element-222">
            <div className="flex items-start gap-3" data-id="element-223">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'completo' ? 'border-brand-yellow' : 'border-gray-600'}`} data-id="element-224">
                {selected === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-brand-yellow" data-id="element-225" />}
              </div>
              <div data-id="element-226">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-227">
                  <span className="text-base" data-id="element-228">🏆</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-229">
                    MEGA PACK + SISTEMA FAMILIA ORGANIZADA™
                  </h4>
                </div>
                <div className="flex flex-wrap gap-2 mb-2" data-id="element-230">
                  <span className="bg-brand-yellow text-black text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-231">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-600 text-white text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-232">
                    AHORRÁS S/.30
                  </span>
                </div>
                <p className="text-xs text-gray-400" data-id="element-233">
                  6 tomos + 6 bonos + Sistema Familia Organizada™
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-234">
              <div className="text-xs text-gray-600 line-through" data-id="element-235">S/.99.90</div>
              <div className="text-2xl font-black text-white" data-id="element-236">S/.69.90</div>
            </div>
          </div>
        </button>

        {/* Payment Method Selector */}
        <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-4 mt-4 mb-4" data-id="element-237">
          <p className="text-[13px] font-bold text-white mb-1 text-center" data-id="element-238">
            Puedes pagar con:
          </p>
          <div className="flex flex-col gap-2 max-w-[280px] mx-auto" data-id="element-239">
            <button onClick={() => setPaymentMethod('tarjeta')} className="flex items-center gap-3 text-left group" data-id="element-240">
              <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors ${paymentMethod === 'tarjeta' ? 'border-brand-yellow' : 'border-gray-600'}`} data-id="element-241">
                {paymentMethod === 'tarjeta' && <div className="w-2 h-2 rounded-full bg-brand-yellow" data-id="element-242" />}
              </div>
              <span className={`text-xs transition-colors ${paymentMethod === 'tarjeta' ? 'text-white font-bold' : 'text-gray-400'}`} data-id="element-243">
                🔘 Pago con tarjeta (recomendado)
              </span>
            </button>
            <button onClick={() => setPaymentMethod('yape')} className="flex items-center gap-3 text-left group" data-id="element-244">
              <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors ${paymentMethod === 'yape' ? 'border-brand-yellow' : 'border-gray-600'}`} data-id="element-245">
                {paymentMethod === 'yape' && <div className="w-2 h-2 rounded-full bg-brand-yellow" data-id="element-246" />}
              </div>
              <span className={`text-xs transition-colors ${paymentMethod === 'yape' ? 'text-white font-bold' : 'text-gray-400'}`} data-id="element-247">
                🔘 Pago con Yape / métodos locales
              </span>
            </button>
          </div>
        </div>

        {/* CTA Button */}
        <a href={checkoutLinks[selected][paymentMethod]} className="block w-full bg-brand-yellow hover:bg-brand-yellowHover text-black md:text-lg py-4 px-6 rounded-xl shadow-[0_4px_20px_0_rgba(251,191,36,0.4)] transition-all hover:scale-[1.02] text-center mb-4 text-[14px] font-[900]" data-id="element-248">
          {selected === 'completo' ? 'SÍ, QUIERO EL MEGAPACK + SISTEMA COMPLETO →' : 'QUIERO MI MEGAPACK AHORA →'}
        </a>

        {/* Subtitle */}
        <p className="text-center text-xs text-gray-500 italic mb-6 max-w-sm mx-auto leading-relaxed" data-id="element-249">
          {selected === 'completo' ? 'La opción más elegida por quienes quieren acompañar esta etapa con claridad real' : 'Incluye los 6 tomos completos y los 6 bonos estratégicos'}
        </p>

        {/* Trust badges */}
        <div className="bg-gray-900 border border-gray-800 rounded-xl py-3 px-4" data-id="element-250">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-gray-400" data-id="element-251">
            <div className="flex items-center gap-1.5" data-id="element-252">
              <Lock size={13} className="text-brand-yellow" data-id="element-253" />
              Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-254">
              <Zap size={13} className="text-brand-yellow" data-id="element-255" />
              Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5" data-id="element-256">
              <ShieldCheck size={13} className="text-brand-yellow" data-id="element-257" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-258">
              <CreditCard size={13} className="text-brand-yellow" data-id="element-259" />
              Pago local
            </div>
          </div>
          <div className="flex items-center justify-center gap-2 mt-2.5 pt-2.5 border-t border-gray-800" data-id="element-260">
            <CreditCard size={14} className="text-brand-yellow flex-shrink-0" data-id="element-261" />
            <span className="text-[11px] text-gray-400 font-medium text-center" data-id="element-262">
              Paga con Yape, tarjeta o MercadoPago de forma segura y accede al
              material HOY
            </span>
          </div>
        </div>
      </div>
    </section>;
}